import {faTranslations} from './fa';
import {enTranslations} from './en';

const languageFiles = {
	fa_IR: faTranslations,
	en_US: enTranslations,
};

export const LanguageLoader = (language) => 
{
	const selectedLanguage = languageFiles[language];
	if (selectedLanguage)
	{
		return selectedLanguage;
	}
	// Default to Persian or handle unsupported languages
	return faTranslations;
};